/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：267
 */

"use strict"

var r
export { r as a };
(function (e) {
  e.SETTER = "SETTER"
  e.DELETE = "DELETE"
  e.QUERY = "QUERY"
  e.CLEAR = "CLEAR"
})(r || (r = {}))
export default r
